export default {
  "dashboard": {
    "create_modal_dialog": {
      "title": "Create a new {type}.",
      "folder_name_input": "Dashboard name",
      "submit_button": "Create dashboard"
    },
    "delete_modal_dialog": {
      "title": "Delete dashboard {name} ?",
      "description": "Are you sure you want to delete this dashboard?",
      "submit_button": "Delete dashboard"
    },
    "rename_modal_dialog": {
      "title": "Rename {type} {name}",
      "name_input": "{type} new name",
      "submit_button": "Update"
    },
    "add_widget_modal_dialog": {
      "title": "Add Visualization Widget",
      "description": "Select the visualization you want to add to your dashboard.",
      "tab": {
        "all": "All",
        "BAR_CHART": "Bar",
        "LINE_CHART": "Line",
        "PIE_CHART": "Pie",
        "DOUGHNUT_CHART": "Doughnut",
        "COLUMN_METRIC": "Metric",
        "TABLE": "Table",
        "GAUGE_CHART": "Gauge"
      },
      "add_button": "Add"
    },
    "add_filters_modal_dialog": {
      "title_add": "Add Dynamic Filters",
      "title_edit": "Update Dynamic Filters",
      "description": "Select which data column you want to be able to filter in your dashboard.",
      "label": "Filter Label",
      "type": "Input Type",
      "type_options": {
        "select": "Option Dropdown",
        "string": "Text",
        "number": "Number",
        "boolean": "Boolean",
        "date": "Date",
        "datetime": "Date with Time",
        "date_range": "Date Range",
        "datetime_range": "Date Range with Time"
      },
      "columns": "Column(s)",
      "add_column_button": "Add column to this filter",
      "add_filter_button": "New Filter",
      "delete_filter_button": "Delete Filter",
      "submit_button": "Add {count} filters to dashboard",
      "update_button": "Update filters",
      "default_value": "Valeur par défaut"
    },
    "table_widget_dialog": {
      "title": "Add Data Table",
      "description": "Select which column from the visualization to view the data in your dashboard.",
      "viz": "Select Visualization",
      "columns": "Column(s)",
      "add_column_button": "Add column to this table",
      "submit_button": "Add table to dashboard",
      "update_button": "Update table"
    },
    "edit_button": "Edit",
    "rename_button": "Rename",
    "duplicate_button": "Dupliquer",
    "duplicate_success": "Tableau de bord dupliqué avec succès",
    "edit_dashboard_button": "Edit Dashboard",
    "clear_filters_button": "Effacer les filtres",
    "clear_filters_confirm_button": "Confirmer ?",
    "view_only_button": "View Mode",
    "view_only_disabled_tooltip": "Enregistrez vos modifications avant de passer en mode Affichage",
    "select_value": "Select value",
    "dynamic_filters": {
      "loading_tooltip": "En attente de la fin du chargement de la visualisation",
      "loading_options": "Chargement..."
    },
    "retry_button": "Retry",
    "settings_modal_dialog": {
      "title": "Dashboard Settings",
      "columns_label": "Number of Columns",
      "columns_required": "Please enter number of columns",
      "gap_label": "Gap Between Elements (px)",
      "gap_required": "Please enter gap size",
      "row_height_label": "Hauteur de ligne (px)",
      "row_height_required": "Veuillez entrer la hauteur de ligne",
      "recalculate_label": "Recalculer les positions des widgets",
      "cache_enabled_label": "Mise en cache des résultats de requête",
      "cache_enabled_off": "Désactivée",
      "cache_enabled_on": "Activée — mettre les résultats en cache et les réutiliser",
      "cache_refresh_label": "Comportement d'actualisation",
      "cache_refresh_no_auto": "Aucune actualisation automatique",
      "cache_refresh_auto": "Actualisation automatique — garder à jour automatiquement les résultats récemment utilisés",
      "cache_refresh_custom": "Personnalisé — garder à jour les combinaisons de filtres que vous choisissez",
      "cache_custom_combinations_label": "Combinaisons de filtres à garder à jour",
      "cache_custom_combinations_placeholder": "Choisissez les combinaisons de filtres à actualiser (aperçu)",
      "cache_custom_combination_add": "Ajouter une combinaison",
      "cache_auto_recency_days_label": "Fenêtre de récence (jours)",
      "cache_auto_recency_days_help":
        "Depuis combien de temps un résultat en cache doit avoir été utilisé pour que l'actualisation automatique le garde à jour. Distinct de la limite d'ancienneté ci-dessus.",
      "staleness_tolerance_label": "Afficher les données en cache jusqu'à (ancienneté)",
      "staleness_tolerance_help": "L'ancienneté maximale d'un résultat en cache pour qu'il reste affiché pendant le chargement des données fraîches. S'applique à tous les modes de mise en cache.",
      "staleness_tolerance_required": "Veuillez saisir une tolérance d'ancienneté",
      "staleness_tolerance_minimum": "La tolérance d'ancienneté doit être d'au moins 1 minute",
      "staleness_unit_days": "jours",
      "staleness_unit_hours": "h",
      "staleness_unit_minutes": "min",
      "submit_button": "Apply"
    },
    "widget_cache_staleness_tag": "En cache {when}",
    "widget_cache_staleness_tag_generic": "Données en cache",
    "image_upload_widget": {
      "no_image": "No image uploaded",
      "edit_image_button": "Edit photo",
      "upload_button": "Upload an Image",
      "uploading": "Uploading...",
      "supported_formats": "Supported formats: JPG, PNG, SVG (Max 375KB)"
    },
    "widget_errors_title": "{count, plural, one {# widget n'a pas pu se charger} other {# widgets n'ont pas pu se charger}}",
    "widget_errors_description": "Certains widgets ont rencontré des erreurs lors du chargement de leurs données.",
    "widget_errors_retry_all": "Tout réessayer",
    "widget_errors_show_dashboard": "Afficher le tableau de bord",
    "widget_render_error_title": "Ce widget n'a pas pu être affiché",
    "widget_render_error_detail": "Widget {type} ({id})"
  }
};
